import axios from 'axios'

const PostingService = {
  async get (params = {}) {
    return axios.get('prd/purchase-order/postings', { params })
  },

  async histories (params = {}) {
    return axios.get('prd/reports/purchase-order/posting-histories', { params })
  },

  async show (id) {
    return axios.get(`prd/purchase-order/postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/purchase-order/postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/purchase-order/postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/purchase-order/postings/${data.id}`, { data })
  }
}

export default PostingService
